import { captureException, withScope } from '@sentry/browser';
import React, { ErrorInfo, ReactNode } from 'react';

export class ErrorBoundary extends React.Component<{ children?: ReactNode }> {
    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        withScope((scope) => {
            scope.setExtra('componentStack', errorInfo.componentStack);
            captureException(error);
        });
    }

    render() {
        return this.props.children;
    }
}
